import { Chip as ChipCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Chip = lib.styled(ChipCore)`
  background-color: ${colors.yellow04} !important;

  .MuiChip-avatar {
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    svg {
      display: block;
    }
  }

  .MuiChip-label {
    padding-left: 10px;
    padding-right: 6px;
    color: ${colors.white};
  }
`;
